import { useTranslations } from 'next-intl';
import { useTenantSlug } from '@/hooks/use-tenant-slug';
import { getTenantConfig } from '@/tenants/config';

/**
 * Resolves the donation "impact" line shown beneath the donate button on the
 * shared amount card and donation modal.
 *
 * Single source of truth so the same per-tenant rule applies everywhere the
 * line renders. Tenants can override the DGR-specific i18n default
 * (`donate.form.impactMessage`) via `TenantConfig.donationImpactMessage`:
 * - `undefined` → fall back to the i18n string (DGR/DGD default).
 * - `null`      → render nothing (returns `null`).
 * - `string`    → render that exact copy.
 *
 * @returns The impact line to render, or `null` to render nothing.
 */
export function useDonationImpactMessage(): string | null {
  const tForm = useTranslations('donate.form');
  const tenantSlug = useTenantSlug();
  const override = getTenantConfig(tenantSlug).donationImpactMessage;

  if (override === null) return null;
  if (override !== undefined) return override;
  return tForm('impactMessage');
}
